import { Popper } from '@mui/base/Popper';
import { forwardRef, useRef } from 'react';
import { DropdownTransition } from './DropdownTransition';
const DefaultRootSlot = forwardRef(function DefaultRootSlot(props, ref) {
  const {
    ownerState,
    ...rest
  } = props;
  return <div {...rest} ref={ref} />;
});
export const AnimatedPopover = forwardRef(
// eslint-disable-next-line @typescript-eslint/no-shadow
function AnimatedPopover({
  anchorEl,
  open,
  PopperProps,
  children,
  ...forwardedProps
}, forwardedRef) {
  // Keep children from changing while doing a close animation. This is needed
  // because Material UI's useAutocomplete removes all options from the drop
  // down to close it.
  const childrenWhenLastOpen = useRef(children);
  if (open) {
    childrenWhenLastOpen.current = children;
  }

  /**
   * Prevent the following error:
   * ```
   * The `anchorEl` prop provided to the component is invalid.
   * It should be an HTML element instance or a virtualElement.
   * ```
   */
  if (!anchorEl) {
    return null;
  }
  return <Popper {...PopperProps} slots={{
    root: PopperProps?.slots?.root ?? DefaultRootSlot
  }} anchorEl={anchorEl} open={open} transition>
				{({
      TransitionProps
    }) => <DropdownTransition {...TransitionProps}>
						<div ref={forwardedRef} {...forwardedProps}>
							{childrenWhenLastOpen.current}
						</div>
					</DropdownTransition>}
			</Popper>;
});